import React from "react";
import { SecondaryLabel } from "@bloomberg/media-ui-article";
import { Lock } from "@bloomberg/media-ui-icons";

import { Story } from "~types/types";
import { useTranslateMessage } from "~utils/i18n/translate";

import styles from "./styles.module.css";

interface BoxedLabelProps {
    story: Story;
}

export default function SubscriberLabel({
    story,
}: BoxedLabelProps): React.JSX.Element | null {
    const { premium, archived } = story;
    const translateMessage = useTranslateMessage();

    const showSubscriberOnlyLabel = premium || archived;

    if (showSubscriberOnlyLabel) {
        const text = translateMessage(
            {
                id: "subscribersOnly",
                defaultMessage: "This article is for <b>subscribers only</b>.",
            },
            {
                b: (chunks: string) => <b>{chunks}</b>,
            }
        );

        return (
            <SecondaryLabel
                text={<div>{text}</div>}
                icon={<Lock />}
                className={styles.subscriberLabel}
            />
        );
    }

    // add other secondary label states here
    return null;
}
